import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'

import { ApiError } from '@/lib/api'
import { hydrateIdentity, useAuth } from '@/lib/auth'
import { IdentityBrowserEvents, useRefreshOnEvent } from '@/lib/browser-events'
import { useSelectedEntity } from '@/modules/hierarchy'

export function useEntityContextSync(): void {
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuth()
  const { entityId, entity } = useSelectedEntity()

  const scopedEntityId = user?.entityId

  const refreshPermissions = async () => {
    if (entityId != null) await hydrateIdentity(entityId)
  }

  useRefreshOnEvent(IdentityBrowserEvents.permissionsChanged, refreshPermissions)

  useEffect(() => {
    if (isAuthenticated && entityId != null && scopedEntityId !== entityId) {
      void hydrateIdentity(entityId)
    }
  }, [isAuthenticated, entityId, scopedEntityId])

  const error = entity.error
  const scopedIdentityReady = user?.entityId === entityId
  const hasScopedPermissions = scopedIdentityReady && (user.permissions?.length ?? 0) > 0
  useEffect(() => {
    if (
      error instanceof ApiError &&
      (error.status === 404 ||
        (error.status === 403 && scopedIdentityReady && !hasScopedPermissions))
    ) {
      void navigate({ to: '/' })
    }
  }, [error, hasScopedPermissions, navigate, scopedIdentityReady])
}
